import PropTypes from "prop-types";
import React from "react";
import styles from "./styles";
import { Drawer, withStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { openMedia } from "../../store/helpers";
import RightMedia from "../header/RightMedia";

class MobileMedia extends React.Component {
	render() {
		const { classes, opened, hidden } = this.props;

		return (
			<div className={classes.mobileMedia}>
				<Drawer
					anchor="right"
					classes={{
						paper: classes.drawerPaper,
						root: hidden ? classes.hidden : ""
					}}
					open={opened}
					variant="persistent"
				>
					<RightMedia classes={classes} />
				</Drawer>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	...state.helpers.media
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			handleOpenMedia: openMedia
		},
		dispatch
	);

MobileMedia.propTypes = {
	classes: PropTypes.object.isRequired,
	handleOpenMedia: PropTypes.func.isRequired,
	hidden: PropTypes.bool.isRequired,
	opened: PropTypes.bool.isRequired
};

export default withStyles(styles)(
	connect(mapStateToProps, mapDispatchToProps)(MobileMedia)
);
